import { Consultant, FixePriceConsultant, IsNeomyticConsultant } from './interfaces/Consultant';
import { IsEuropeIntracomCountry, IsVIESSupport } from './interfaces/Countries';
import { Customer } from './interfaces/Customer';
import * as Data from './store/Data';

export const DataHelpers = {
    GetInvoiceFromInvoiceid: (d: Data.DataState, invoiceid: string | null | undefined): Data.Invoice | null => {
        if (invoiceid && d.invoices) {
            const i = d.invoices.find((i) => i.invoiceid === invoiceid);
            if (i) return i;
        }
        return null;
    },
    GetCustomerFromId: (d: Customer[] | null | undefined, id: string | null | undefined): Customer | null => {
        if (id && d) {
            const c = d.find(e => e.customerid === id);
            if (c) return c;
        }
        return null;
    },
    GetArticleFromId: (d: Data.DataState, id: string | null | undefined): Data.Article | null => {
        if (id && d.articles) {
            const a = d.articles.find(e => e.articleid === id);
            if (a) return a;
        }
        return null;
    },
    GetConsultantFromId: (d: Consultant[] | undefined, id: string | null | undefined): Consultant | null => {
        if (id && d) {
            const c = d.find(e => e.consultantid === id);
            if (c) return c;
        }
        return null;
    },
    GetConsultantFixePriceForMounth: (d: FixePriceConsultant[] | undefined, c: Consultant | undefined, date: Date): number => {
        const dd = new Date(Date.now());
        const firstDayOfMonth = new Date(Date.UTC(dd.getFullYear(), dd.getMonth() - 1));
        if (date.getTime() > firstDayOfMonth.getTime()) {
            return 0;
        }
        if (d && c) {
            const f = d.find(e => e.consultantid === c.consultantid && e.dateDebut && e.dateFin && (new Date(e.dateDebut).getTime() <= date.getTime()) && (new Date(e.dateFin).getTime() >= date.getTime()));
            if (f) {
                return f.price;
            }
        }
        return 0;
    },
    GetInvoiceTotalFromInvoice: (d: Data.DataState, consultant: Consultant | undefined, customer: Customer | undefined, i: Data.Invoice): number => {
        let total = 0;
        const IsNeomyticInvoice = IsNeomyticConsultant(i.consultantid);
        const IsCustomerExemptFromTax = customer && customer.vatexempt ? true : false;
        const IsCustomerIntraCommunityTax = customer && customer.countryCode && consultant && consultant.countryCode ? customer.countryCode.toUpperCase() !== consultant.countryCode.toUpperCase() && IsEuropeIntracomCountry(customer.countryCode) : false;
        if (d.timeSheetEntries) {
            d.timeSheetEntries.filter(ts => (IsNeomyticInvoice && ts.invoiceid === i.invoiceid) || (!IsNeomyticInvoice && ts.consultantInvoiceid === i.invoiceid))
                .forEach((t) => {
                    const pa = d.projectsAssigments ? d.projectsAssigments.find(e => e.projectAssignmentid === t.projectAssignmentid) : undefined;
                    if (pa) {
                        let lineTotal = Math.round((IsNeomyticInvoice ? pa.customerPrice : pa.consultantPrice) * t.count * 100) / 100;
                        if (i.isCreditNote) {
                            lineTotal = -lineTotal;
                        }
                        if (!IsCustomerExemptFromTax && !IsCustomerIntraCommunityTax) {
                            const tva = (1 + ((IsNeomyticInvoice ? pa.customerVatcode : pa.consultantVatcode) / 100));
                            total = total + Math.round(((lineTotal * tva) + Number.EPSILON) * 100) / 100;
                        }
                        else {
                            total = total + lineTotal;
                        }
                    }
                });
        }
        if (d.sales) {
            d.sales.filter(ts => ts.invoiceid === i.invoiceid)
                .forEach((t) => {
                    let lineTotal = Math.round(t.unitPrice * t.count * 100) / 100;
                    if (i.isCreditNote) {
                        lineTotal = -lineTotal;
                    }
                    if (!IsCustomerExemptFromTax && !IsCustomerIntraCommunityTax) {
                        const tva = (1 + (t.vatcode / 100));
                        total = total + Math.round(((lineTotal * tva) + Number.EPSILON) * 100) / 100;
                    }
                    else {
                        total = total + lineTotal;
                    }
                });
        }
        if (i.invoiceEntries) {
            i.invoiceEntries.forEach((t) => {
                const lineTotal = Math.round(t.sellPrice * t.count * 100) / 100;
                if (!IsCustomerExemptFromTax && !IsCustomerIntraCommunityTax) {
                    const tva = (1 + (t.vatcode / 100));
                    total = total + Math.round(((lineTotal * tva) + Number.EPSILON) * 100) / 100;
                }
                else {
                    total = total + lineTotal;
                }
            });
        }
        return total;
    },
    GetInvoiceTotalFromInvoiceHTVA: (d: Data.DataState, i: Data.Invoice): number => {
        let total = 0;
        const IsNeomyticInvoice = IsNeomyticConsultant(i.consultantid);
        if (d.timeSheetEntries) {
            d.timeSheetEntries.filter(ts => (IsNeomyticInvoice && ts.invoiceid === i.invoiceid) || (!IsNeomyticInvoice && ts.consultantInvoiceid === i.invoiceid))
                .forEach((t) => {
                    const pa = d.projectsAssigments ? d.projectsAssigments.find(e => e.projectAssignmentid === t.projectAssignmentid) : undefined;
                    if (pa) {
                        total = total + Math.round(pa.customerPrice * ((i.isCreditNote) ? -t.count : t.count) * 100) / 100;
                    }
                });
        }
        if (d.sales) {
            d.sales.filter(ts => ts.invoiceid === i.invoiceid)
                .forEach((t) => {
                    total = total + Math.round(t.unitPrice * ((i.isCreditNote) ? -t.count : t.count) * 100) / 100;
                });
        }
        if (i.invoiceEntries) {
            i.invoiceEntries.forEach((t) => {
                total = total + Math.round(t.sellPrice * t.count * 100) / 100;
            });
        }
        return total;
    },
    isBetweenDate: (dateDebut: string | null, dateFin: string | null): boolean => {
        if (dateFin === null) {
            return true;
        }
        if (new Date(dateFin).getTime() > Date.now()) {
            return true;
        }
        return false;
    },
    IsProjectFinished: (p: Data.Project | null): boolean => {
        if (p === null || p.dateFin === null) {
            return false;
        }
        if (new Date(p.dateFin).getTime() < Date.now()) {
            return true;
        }
        return false;
    },
    IsProjectAssigmentFinished: (p: Data.ProjectAssigment | null): boolean => {
        if (p === null || p.dateFin === null) {
            return false;
        }
        if (new Date(p.dateFin).getTime() < Date.now()) {
            return true;
        }
        return false;
    },
    IsConsultantActifOn: (c: Consultant, d: Date): boolean => {
        if (c.consultantActivityPeriodes === null || c.consultantActivityPeriodes === undefined || c.consultantActivityPeriodes.length === 0) {
            return true;
        }
        return undefined !== c.consultantActivityPeriodes.find(p => {
            if (p.dateDebut) {
                const cd = new Date(p.dateDebut);
                if (d >= cd) {
                    if (p.dateFin) {
                        const cf = new Date(p.dateFin);
                        return cf >= d;
                    }
                    else {
                        return true;
                    }
                }
            }
        });
    },
    ProjectAssigmentCompletedQuantity: (p: Data.ProjectAssigment, ts: Data.TimeSheetEntry[]): number => {
        const f = ts.filter(t => t.projectAssignmentid === p.projectAssignmentid);
        let quantity = 0;
        f.forEach((t) => {
            quantity += t.count;
        });
        return quantity;
    },
};